import React, { useCallback, useEffect, useState } from 'react';

import Thumbnail from './Thumbnail';
import TheoryThumbnail from './TheoryThumbnail';
import CompanionThumbnail from './CompanionThumbnail';
import EvilNoundleThumbnail from './EvilNoundleThumbnail';

const TokenThumbnail = ({ type, tokenId }) => {
  switch (type) {
    case 'theory':
      return <TheoryThumbnail tokenId={tokenId} />;
    case 'companions':
      return <CompanionThumbnail tokenId={tokenId} />;
    case 'evil':
      return <EvilNoundleThumbnail tokenId={tokenId} />;
    default:
      return <Thumbnail tokenId={tokenId} />;
  }
};

const ThumbnailGrid = ({ type, tokens, onSelectionChange }) => {
  const [selection, setSelection] = useState({});

  useEffect(() => {
    setSelection(Object.fromEntries(tokens.map((t) => [t, false])));
  }, [tokens]);

  useEffect(() => {
    onSelectionChange(selection);
  }, [onSelectionChange, selection]);

  const toggleSelection = useCallback((id) => {
    setSelection((prevSelection) => ({
      ...prevSelection,
      [id]: !prevSelection[id],
    }));
  }, []);

  return (
    <div className="d-flex flex-wrap justify-content-center">
      {tokens.map((tokenId) => (
        <div
          key={tokenId}
          className={`flex-shrink-0 p-1 m-2 rounded ${
            selection[tokenId] ? 'bg-info' : 'bg-light'
          }`}
          onClick={() => toggleSelection(tokenId)}
          role="button"
        >
          <TokenThumbnail type={type} tokenId={tokenId} />
        </div>
      ))}
    </div>
  );
};

ThumbnailGrid.defaultProps = {
  type: 'noundles',
  tokens: [],
  onSelectionChange: () => {},
};

export default ThumbnailGrid;
